import type { CanvasEdge, CanvasEdgeStyle } from "./domain/types";

export const DEFAULT_CANVAS_EDGE_STYLE: Required<CanvasEdgeStyle> = {
  color: "#64748b",
  width: 2,
  dash: "solid",
  arrowStart: false,
  arrowEnd: true,
};

export function resolveCanvasEdgeStyle(
  edge: Pick<CanvasEdge, "props">,
): Required<CanvasEdgeStyle> {
  const color =
    typeof edge.props.color === "string" && edge.props.color.length > 0
      ? edge.props.color
      : DEFAULT_CANVAS_EDGE_STYLE.color;
  const width =
    typeof edge.props.width === "number" &&
    Number.isFinite(edge.props.width) &&
    edge.props.width > 0
      ? edge.props.width
      : DEFAULT_CANVAS_EDGE_STYLE.width;
  return {
    color,
    width,
    dash:
      edge.props.dash === "dashed" ? "dashed" : DEFAULT_CANVAS_EDGE_STYLE.dash,
    arrowStart:
      typeof edge.props.arrowStart === "boolean"
        ? edge.props.arrowStart
        : DEFAULT_CANVAS_EDGE_STYLE.arrowStart,
    arrowEnd:
      typeof edge.props.arrowEnd === "boolean"
        ? edge.props.arrowEnd
        : DEFAULT_CANVAS_EDGE_STYLE.arrowEnd,
  };
}
